<div class="grid-fluid bg-surface-highlight">
  <div class="cell">
    <div class="grid align-center padding-horizontal-medium padding-bottom-medium document-template padding-vertical-xbig">
      <div class="cell cell-large-col-span-12 text-center margin-bottom-xmedium">
        <h1 class="display-small text-center">{{ data.settings?.heading }}</h1>
        <p *ngIf="data.settings?.subheading" class="text-large margin-top-small">{{ data.settings?.subheading }}</p>
      </div>
      <div class="cell cell-large-col-span-3 flex" *ngFor="let card of data.settings?.cards">
        <open-svg-icon [name]="card.icon" class="medium light tutorial margin-right-xsmall"></open-svg-icon>
        <p class="body margin-bottom-none" [innerHTML]="card.content"></p>
      </div>
      <p *ngIf="data.settings?.terms" class="cell cell-large-col-span-12 text-center margin-top-xmedium" [innerHTML]="data.settings?.terms"></p>
    </div>
  </div>
</div>